/**
 * Check if the user agent indicates a mobile device.
 * This is the function that replaces my-ua-parser's getDevice().type === 'mobile'.
 */
export function isMobileDevice(ua) {
    if (!ua)
        return false;
    // Check for mobile indicators
    // iPhone is always mobile
    if (/iphone/i.test(ua))
        return true;
    // iPod is always mobile
    if (/ipod/i.test(ua))
        return true;
    // Android with Mobile is mobile (Android without Mobile is tablet)
    if (/android/i.test(ua) && /mobile/i.test(ua))
        return true;
    // Windows Phone
    if (/windows phone/i.test(ua))
        return true;
    // BlackBerry
    if (/blackberry|bb10/i.test(ua))
        return true;
    return false;
}
export const isMobile = (ua) => (ua?.includes('Mobile') && !ua?.includes('iPad')) ?? false;
export const isAndroidMobileWebView = (ua) => 
// Android WebView (modern): UA contains 'wv'
// Android WebView (older): UA contains 'version/'
ua?.includes('wv') || ua?.includes('version/') || false;
export const isIOSMobileWebView = (ua) => {
    if (!ua)
        return false;
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
};
export const isMobileWebView = (ua) => {
    return isAndroidMobileWebView(ua) || isIOSMobileWebView(ua);
};
//# sourceMappingURL=device.js.map